import { TAgentService } from '@/models/agents';
import { TRatesResponse } from '@/models/rates';

export function calculateCogsInEUR(
  cogsByCurrency: Record<string, number>,
  rates: TRatesResponse,
): number {
  return Object.entries(cogsByCurrency).reduce((acc, [currency, amount]) => {
    const currencyCode = currency.toUpperCase();
    if (currencyCode === 'EUR') {
      return acc + amount;
    }
    const rate = rates?.quotes[`EUR${currencyCode}`];
    if (rate) {
      return acc + amount / rate;
    }
    return acc;
  }, 0);
}

export function mergeCogsByCurrency(
  servicesCogs: Record<string, number>[],
): Record<string, number> {
  return servicesCogs.reduce((acc, cogs) => {
    Object.entries(cogs).forEach(([currency, amount]) => {
      acc[currency] = (acc[currency] || 0) + amount;
    });
    return acc;
  }, {});
}

export const convertToEur = (
  value: number,
  currency: string,
  rates: TRatesResponse,
) => {
  const rate = rates?.quotes[`EUR${currency.toUpperCase()}`];
  if (!rate) {
    console.warn(`Unable to convert ${currency} to EUR, rate not found`);
  }
  return value / (rate || 1);
};

export function groupCogsByCurrency(
  agentServices: Pick<TAgentService, 'cogs' | 'currency'>[],
) {
  return agentServices.reduce(
    (acc, service) => {
      const currency = service.currency.toUpperCase();
      acc[currency] = (acc[currency] || 0) + service.cogs;
      return acc;
    },
    {} as Record<string, number>,
  );
}
